import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { Route, Routes } from "react-router-dom";
import { ApiInterface } from "../API";
import { axInstBasic } from "../components/Service/Service";
import {
  setArnValues,
  setVasOptions,
  setVasType,
} from "../store/Slices/homeAPISlice";
import AdminFleetDetails from "./AdminFleetDetails";
import AdminHome from "./AdminHome";
import AdminKeyInsight from "./AdminKeyInsight";
import "./index.css";
import { generateToken } from "../utils";
import { useNavigate } from "react-router-dom";

function Admin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { arnNumber, arnListForAdmin, arnValues } = useSelector(
    (state) => state.homeApi
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlParts = window.location.hash.split("?");
    const baseHash = urlParts[0];
    const hash = window.location.hash;
    const queryIndex = hash.indexOf("?");
    const queryString = hash.substring(queryIndex + 1);
    const params = new URLSearchParams(queryString);
    const token = params.get("token");
    const user_id = params.get("username");

    if (!token || !user_id) {
      window.location.href =
        "https://customer360.cv.tatamotors/";
      return; // prevent rest of code from running
    }

    // Clean up URL hash after 5 seconds

    // Fetch token check
    const fetchData = async () => {
      try {
        const res = await axInstBasic.post(
          `${process.env.REACT_APP_API_ENDPOINT_URL}fetch_token`,
          { token }
        );

        const result = res?.data?.message;

        // console.log("Token Check Result:", res.data.message);

        if (Array.isArray(result) && result.length === 0) {
          await insertToken();
        } else {
          window.location.href =
            "https://customer360.cv.tatamotors/";
          return;
        }
      } catch (error) {
        console.error("Fetch Token API error:", error);
      }
    };

    // Insert token if not already in DB
    const insertToken = async () => {
      try {
        const res = await axInstBasic.post(
          `${process.env.REACT_APP_API_ENDPOINT_URL}token-insertion`,
          { user_id, token }
        );
        // console.log("Token Insert Result:", res);
        return res?.data?.message;
      } catch (error) {
        console.error("Insert Token API error:", error);
      }
    };
    setTimeout(() => {
      const newHash = baseHash || "#/admin";
      window.history.replaceState(
        null,
        "",
        `${window.location.origin}${window.location.pathname}${newHash}`
      );
    }, 5000);
    fetchData();
  }, []);

  useEffect(() => {
    if (arnNumber) {
      if (arnNumber?.value === "all") {
        const values = arnListForAdmin
          ?.filter((option) => option.value !== "all")
          ?.map((option) => option.value);
        const encryptedArn = generateToken(values);
        dispatch(setArnValues(encryptedArn));
        getvasdataHandler(encryptedArn);
      } else {
        const singleValueArray = arnNumber?.value;
        const encryptedArn = generateToken(singleValueArray);
        dispatch(setArnValues(encryptedArn));
        getvasdataHandler(encryptedArn);
      }
    }
  }, [arnNumber]);

  const getvasdataHandler = async (arnValues) => {
    try {
      const formData = new FormData();
      formData.append("encrypted_arn", arnValues);
      const response = await ApiInterface.getvasData(formData);
      if (response.status === 200) {
        const data = response.data;
        const vasListOptions = data?.map((item) => ({
          label: item?.vas_type,
          value: item?.vas_type,
        }));
        dispatch(setVasOptions(vasListOptions));
        dispatch(setVasType(vasListOptions[0]));
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching VAS data:", error);
    }
  };

  return (
    <div className="layout_wrapper">
      <Routes>
        <Route exact path="/" element={<AdminHome />} />
        <Route path="/admin-fleet-details" element={<AdminFleetDetails />} />
        <Route path="/admin-key-insight" element={<AdminKeyInsight />} />
      </Routes>
    </div>
  );
}

export default Admin;
